import { gsap } from 'gsap';

export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }

  return window.matchMedia(REDUCED_MOTION_QUERY).matches;
};

export const applyReducedMotion = (
  reduce: () => void,
  animate: () => void,
): void => {
  if (prefersReducedMotion()) {
    reduce();
    return;
  }

  animate();
};

export const setInstantStyles = (
  target: gsap.TweenTarget,
  vars: gsap.TweenVars,
): void => {
  if (!target) {
    return;
  }

  gsap.set(target, vars);
};
